module.exports = __webpack_public_path__ + "img/donante-gobierno-cdmx.97d6c134.png";